import React, { useEffect } from 'react';
import { connect, useSelector, useDispatch } from 'react-redux';
import * as debounce from 'lodash.debounce';
import QuickSearchResult from './QuickSearchResult';
import { setSearchQuery, handleKeyDown, displayResult, setCoords, setFilteredStores, receive } from '../Actions/HomeSearch.action';
import { getDistanceFromLatLonInKm } from '../Services/StoreService';


const HomeSearch = (props) => {    
    const { query, result, showResult, coords, homeStores } = useSelector((state) => state.homeSearch);
    const dispatch = useDispatch();    
    
    const setCoordsComponent = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                ({ coords }) => dispatch(setCoords({
                    lat: coords.latitude,
                    lng: coords.longitude
                }))
            )
        }  
    }

    const onSearch = (text) => {
        dispatch(setSearchQuery(text));
        debouncedQuery(dispatch);
    }

    const onKeyDown = (event, opt) => {
        dispatch(handleKeyDown(event, opt))
    }

    const onClose = () => dispatch(displayResult(false));

    const debouncedQuery = debounce((dispatch) => {
        dispatch(updateFilteredStores(true, query, coords, homeStores));
    }, 100);
    
    const searchUrl = () => {
        return window.__litium.quickSearchUrl + (query.length > 0 ? `?q=${query}&onlystores=true` : '');
    }

    
    useEffect(() => {
        document.body.classList.toggle('force-body-over-header', showResult);
    }, [showResult]);

    useEffect(() => {
        setCoordsComponent();
    }, []);    

    useEffect(() => {
        updateFilteredStores(false, query, coords, homeStores);
    }, [coords]);

    const updateFilteredStores = (updateResults, query, coords, homeStores) => {    
        const searchQuery = query.trim().toLowerCase();
    
        let stores = homeStores ? homeStores.filter(({ storeCoordLat, storeCoordLong }) => (!!storeCoordLat || storeCoordLat === 0) && (!!storeCoordLong || storeCoordLong === 0))
            .map(({ ...other }, index) => ({
                ...other, index: index + 1
            })) : [];
        if (searchQuery.length > 0) {
            stores = stores.filter(({
                storeName,
                storeAddress,
                storeCity,
                storeRegion,
                storePostalCode
            }) => {
                const targetToSearch = [
                    storeName,
                    storeAddress,
                    storeCity,
                    storeRegion,
                    storePostalCode
                ].join(' ').toLowerCase();
                return targetToSearch.includes(searchQuery);
            })
        }
    
        if (coords && coords.lat && coords.lng) {
            let nearestStores = [];
            stores.forEach((store) => {
                nearestStores.push({
                    index: store.index,
                    distance: getDistanceFromLatLonInKm(store.storeCoordLat, store.storeCoordLong, coords.lat, coords.lng)
                });
            });
            nearestStores.sort((a, b) => {
                return a.distance - b.distance;
            });
    
            const nearestStoresIndexes = nearestStores.map(store => store.index);
            stores.sort((a, b) => nearestStoresIndexes.indexOf(a.index) - nearestStoresIndexes.indexOf(b.index));
        }
        stores = stores.slice(0, 6);
        dispatch(setFilteredStores(stores))
    
        // Dirty solution for results
        if (updateResults) {
            let results = [];
            stores.forEach((store) => {
                results.push({
                    category: "Stores",
                    name: store.storeName,
                    showAll: false,
                    url: store.urlToStore
                });
            });
            if (results && results.length > 0) {
                results.push({
                    category: "ShowAll",
                    name: "Vis alle søkeresultater",
                    searchDisplayName: null,
                    showAll: true,
                    url: null,
                });
            } else {
                results.push({
                    category: "NoHit",
                    name: "Ingen treff",
                    searchDisplayName: null,
                    showAll: false,
                    url: null,
                });
            }
            dispatch(receive(results));
        }
    }    

    return <>
        <div className="home-search">
            <div className="home-search-wrapper">
                <input className="home-search__input" type="search" placeholder="Finn din lokale optiker" autoComplete="off"
                    value={query} onChange={event => onSearch(event.target.value)}
                    onKeyDown={event => onKeyDown(event, { searchUrl: searchUrl() })} />
                <span className="geolocation-btn" onClick={() => setCoordsComponent()}></span>
                <span className="magnifier-btn" onClick={() => { location.href = searchUrl() }}></span>
                {showResult && <QuickSearchResult result={result} searchUrl={searchUrl()} showResult={showResult} query={query} onClose={onClose} isHomeSearch={true} />}
            </div>
        </div>
        {showResult && <div className="background-cloack"></div>}
    </>
}

export default HomeSearch;